import { Model } from '@nozbe/watermelondb'
import { field, date, json } from '@nozbe/watermelondb/decorators'
import { toRaw } from './utils';

export const MediaColumns = [
    { name: 'model_type', type: 'string' },
    { name: 'model_id', type: 'string' },
    { name: 'collection_name', rawName: 'collectionName', type: 'string' },
    { name: 'name', type: 'string' },
    { name: 'file_name', type: 'string' },
    { name: 'mime_type', type: 'string' },
    { name: 'disk', type: 'string' },
    { name: 'conversions_disk', type: 'string' },
    { name: 'type', type: 'string' },
    { name: 'extension', type: 'string' },
    { name: 'humanReadableSize', type: 'string' },
    { name: 'preview_url', type: 'string' },
    { name: 'original_url', type: 'string' },
    { name: 'url', rawName: 'fullUrl', type: 'string' },
    { name: 'thumb_url', rawName: 'thumbUrl', type: 'string' },
    { name: 'size', type: 'string' },
    { name: 'order_column', type: 'number' },
    { name: 'manipulations', type: 'string' },
    { name: 'custom_properties', type: 'string' },
    { name: 'generated_conversions', type: 'string' },
    { name: 'responsive_images', type: 'string' },
    { name: 'created_at', type: 'number' },
    { name: 'updated_at', type: 'number' },
    
    { name: 'isNew', type: 'number' },
    { name: 'content', type: 'string' },
]

export class Media extends Model {
    static table = 'media'

    @field('model_type') modelType
    @field('model_id') modelId
    @field('collection_name') collectionName
    @field('name') name
    @field('file_name') fileName
    @field('mime_type') mimeType
    @field('disk') disk
    @field('conversions_disk') conversionsDisk
    @field('type') type
    @field('extension') extension
    @field('humanReadableSize') humanReadableSize
    @field('preview_url') largeUrl
    @field('url') fullUrl
    @field('thumb_url') thumbUrl
    @field('size') size
    @field('order_column') orderColumn
    @field('manipulations') manipulations
    @json('custom_properties') customProperties
    @json('generated_conversions') generatedConversions
    @json('responsive_images') responsiveImages
    @date('created_at') createdAt
    @date('updated_at') updatedAt
    
    @field('isNew') isNew
    @field('content') content

    toRaw = toRaw.bind(this, MediaColumns)
}